var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown-input',{attrs:{"options":_vm.dropdownOptions,"theme":"primary","position":"left"},on:{"select":_vm.handleDropdownSelect}},[_c('button-input',[_c('span',{staticClass:"switch__current"},[_vm._v(_vm._s(_vm.currentLocale))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"angle-down"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baa8f91e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/LocaleSwitch.vue
// module id = null
// module chunks = 